import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "product-filters__wrapper" }
const _hoisted_2 = { class: "product-filters__bar" }
const _hoisted_3 = { class: "product-filters__group" }
const _hoisted_4 = { class: "num-products" }
const _hoisted_5 = { class: "product-filters__form" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = {
  key: 1,
  class: "mb-3 text-grey-med"
}
const _hoisted_8 = { class: "row" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SearchInput = _resolveComponent("SearchInput")
  const _component_Cta = _resolveComponent("Cta")
  const _component_DropdownPanel = _resolveComponent("DropdownPanel")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DropdownPanel, {
      additionalLabel: "Filters",
      isOpen: $data.isFiltersOpen,
      hideToggle: $data.hideToggle,
      onToggle: $options.handleToggle
    }, {
      "header-content": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString($options.productCountLabel), 1 /* TEXT */)
          ]),
          _createVNode(_component_SearchInput, {
            placeholderText: "search within results",
            onHandleSearch: $options.handleSearch,
            ref: "searchTerm"
          }, null, 8 /* PROPS */, ["onHandleSearch"])
        ])
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            ($props.filters?.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($props.filters, (filter, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "product-filters__form col-sm-4 col-md-4 col-lg-4 pr-0 pl-0"
                  }, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(filter.displayType), _mergeProps(filter, {
                      isSmallLabel: true,
                      showNumResults: true,
                      key: filter.slug,
                      onFilterChange: $options.handleUpdateFilters
                    }), null, 16 /* FULL_PROPS */, ["onFilterChange"]))
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, "No Filters Available"))
          ]),
          _createElementVNode("div", _hoisted_8, [
            (($options.activeFilters > 0 || $data.searchQuery) || !$props.filters?.length)
              ? (_openBlock(), _createBlock(_component_Cta, {
                  key: 0,
                  type: "link",
                  size: "lg",
                  label: "Reset",
                  fitInline: true,
                  onOnClick: $options.handleReset
                }, null, 8 /* PROPS */, ["onOnClick"]))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["isOpen", "hideToggle", "onToggle"])
  ]))
}